import React, { useEffect, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import constants from '@/core/constants';
import { IContentModalProps } from './type';
import { COLOR_TEXT_INFO } from '../../constants';
import iconPiso from '@/assets/icons/icon-piso.svg';
import Modal from '../../../../../../components/Modal';
import iconMappin from '@/assets/icons/icon-map-pin.svg';
import iconAmbiente from '@/assets/icons/icon-ambiente.svg';
import iconTipoClase from '@/assets/icons/icon-tipo-clase.svg';
import Tooltip from '../../../../../../components/Tooltip/Tooltip';
import {
  ContainerDetail,
  DetailRow,
  GoToButton,
  HowToGet,
  SeparatorLine,
  WrapperHowToGet
} from '@/presentation/components/Schedule/components/CourseDetail';
import { Block, Label, Icon } from '../../../../../../components/index';
import { ExamInfo, CourseName, ContainerViewExamMobile } from './styled';
import ModalSchedule from '../../../../components/ModalSchedule/ModalSchedule';
import { ContainerSchedule } from '../../../registrationShift/components/Mobile/styled';

export const InfoContentModal = ({
  show,
  onClose,
  dataCourseExam,
  isMobile = false
}: IContentModalProps) => {
  const [isSimulator, setIsSimulator] = useState(false);
  const [viewTooltip, setViewTooltip] = useState(false);
  const scrollTop = window.scrollY;

  const handlerIsSimulator = () => {
    const simulator = localStorage.getItem('persist:simulator');
    setIsSimulator(
      simulator ? JSON.parse(simulator).isSimulator === 'true' : false
    );
  };

  useEffect(() => {
    document.body.style.overflow = show ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  useEffect(() => {
    if (show) {
      handlerIsSimulator();
    }
  }, [show]);

  if (!show) return null;

  const openMap = (ev: any) => {
    const e = ev;
    e.target.parentElement.blur();
    e.target.blur();
    document.open(
      `${constants.URL_MAPS}${dataCourseExam?.lat},${dataCourseExam?.long}`,
      '',
      'noopener=true'
    );
  };

  const contentModal = () => (
    <>
      {onClose && !isMobile && (
        <>
          <Block className="icon" data-testid="btn-close-modal">
            <GoToButton padding="10px" buttonType="close" onClick={onClose}>
              <Icon name="x" size={22} />
            </GoToButton>
          </Block>
          <SeparatorLine color="#7A959F" data-testid="separator-line" />
        </>
      )}
      <ContainerSchedule
        isSimulator={isSimulator}
        style={{ gap: 10, paddingTop: 16 }}
      >
        <ContainerViewExamMobile colorTextInfo={COLOR_TEXT_INFO}>
          <CourseName>{dataCourseExam?.name}</CourseName>
          <ExamInfo marginTop={12}>{dataCourseExam?.typeExam}</ExamInfo>
          <ExamInfo marginTop={6}>{dataCourseExam?.date}</ExamInfo>
        </ContainerViewExamMobile>
        <WrapperHowToGet style={{ gap: 8, marginTop: 12 }}>
          <HowToGet style={{ gap: 8, margin: 0 }}>
            <img alt="" src={iconMappin} />
            <div style={{ color: COLOR_TEXT_INFO }}>¿Cómo llegar?</div>
          </HowToGet>
          <SeparatorLine color="#7A959F" />
        </WrapperHowToGet>
        <ContainerDetail
          style={{ borderColor: '#7A959F', marginTop: 14, margin: 0 }}
        >
          <DetailRow
            icon={iconAmbiente}
            labelText="Ambiente:"
            colorTextValue={COLOR_TEXT_INFO}
            valueText={dataCourseExam?.classroom ?? 'No asignado'}
          >
            <OutsideClickHandler onOutsideClick={() => setViewTooltip(false)}>
              <Tooltip
                isTop={scrollTop < 100}
                visible={viewTooltip}
                onClose={() => setViewTooltip(false)}
              >
                <GoToButton
                  buttonType="secondary"
                  padding="10px"
                  onClick={() => setViewTooltip(!viewTooltip)}
                >
                  <Icon name="alert-circle" size={20} />
                </GoToButton>
              </Tooltip>
            </OutsideClickHandler>
          </DetailRow>
          <SeparatorLine color="#7A959F" />
          <DetailRow
            icon={iconTipoClase}
            labelText="Pabellón:"
            colorTextValue={COLOR_TEXT_INFO}
            valueText={dataCourseExam?.pavilion ?? ''}
          />
          <SeparatorLine color="#7A959F" />
          <DetailRow
            icon={iconPiso}
            labelText="Piso:"
            colorTextValue={COLOR_TEXT_INFO}
            valueText={dataCourseExam?.floor ?? 'No asignado'}
          />
        </ContainerDetail>
        <ContainerDetail
          style={{ borderColor: '#7A959F', marginTop: 12, margin: 0 }}
        >
          <Block style={{ color: COLOR_TEXT_INFO }}>
            {dataCourseExam?.campus?.toUpperCase().includes('CAMPUS')
              ? dataCourseExam?.campus
              : `Campus ${dataCourseExam?.campus}`}
          </Block>
          {dataCourseExam?.sede && (
            <Block style={{ marginTop: 4 }}>
              <Label size={14} color="var(--text-text01)" text="Sede:" />
              &nbsp;
              <Label
                size={14}
                color={COLOR_TEXT_INFO}
                text={dataCourseExam?.sede}
              />
            </Block>
          )}
          <Block
            style={{
              marginTop: 8,
              marginBottom: 16,
              color: COLOR_TEXT_INFO
            }}
          >
            {dataCourseExam?.address}
          </Block>
          {dataCourseExam?.lat !== 0 && (
            <GoToButton
              buttonType="secondary"
              padding="8px 16px"
              onClick={openMap}
            >
              <Label text="Ver mapa" />
              &nbsp;
              <Icon name="arrow-right" size={24} />
            </GoToButton>
          )}
        </ContainerDetail>
      </ContainerSchedule>
    </>
  );

  return (
    <>
      {isMobile ? (
        <ModalSchedule
          showModal={show}
          handleClose={() => onClose && onClose()}
          data-testid="cmp-modal-exam-rol-mobile"
        >
          {contentModal()}
        </ModalSchedule>
      ) : (
        <Modal
          IsModalOpen={show}
          handleCloseModal={onClose}
          data-testid="cmp-modal-exam-rol-desktop"
        >
          {contentModal()}
        </Modal>
      )}
    </>
  );
};
